import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type TrpcError, useTRPC } from '@/shared/api';

import type { MyAsset } from '../model/asset';

/**
 * 자료함 — 서버 다운로드 기록 기준 (LIB-U-04 AC-3, 기기와 무관).
 * 비로그인 상태에서는 부르지 않는다(enabled) — 서버는 어차피 UNAUTHORIZED 로 거른다.
 */
export function useMyAssets(enabled: boolean): UseQueryResult<{ items: MyAsset[] }, TrpcError> {
  const trpc = useTRPC();
  return useQuery(trpc.lib.myAssets.queryOptions(undefined, { enabled }));
}
